<template>
  <div class="content-box">
    <Title />
    <div class="title-right">
      <el-link href="https://www.100ec.cn/zt/szfwh/" target='_blank'>
        <img src="https://www.100ec.cn/zt/szfwh/img/960.gif"
      /></el-link>
      
    </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in dataNav"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <div>
      <div v-loading="$store.state.loading">
        <div class="text">
          <a
            v-for="(i, index) in $store.state.text"
            :key="index"
            :href="'/detail--' + i.id + '.html'"
            target="_blank"
          >
            <div class="img">
              <el-image
                v-if="index <= 40"
                :src="require('@/assets/' + index + '.jpg')"
                lazy
              ></el-image>
              <el-image
                v-else
                :src="require('@/assets/' + (index % 40) + '.jpg')"
                lazy
              ></el-image>
            </div>
            <div class="con">
              <span v-html="i.title"></span>
              <p>{{ i.post_date.split(/T|Z/).join(" ") }}</p>
            </div>
          </a>
        </div>
      </div>

      <div v-if="$store.state.more" class="more">
        <el-button type="primary" plain @click="handleSelect3">
          查看更多</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
      activeIndex: "1",
      name: "滚动播报",
      list: "2",
      iflist: "数字生活",
      dataNav: [
        {
          value: "数字生活",
          label: "滚动播报",
        },
        {
          value: "外卖",
          label: "餐饮外卖",
        },
        {
          value: "家政",
          label: "家政服务",
        },
        {
          value: "婚恋",
          label: "婚恋交友",
        },
        {
          value: "社区 服务",
          label: "社区服务",
        },
        {
          value: "家装",
          label: "互联网家装",
        },
        {
          value: "房产",
          label: "互联网房产",
        },
        {
          value: "票务",
          label: "在线票务",
        },
        {
          value: "数字",
          label: "浙江数字",
        },
        {
          value: "服务",
          label: "浙江服务",
        },
        {
          value: "养老",
          label: "养老",
        },
      ],
      params: {
        json: 0,
        filter: ["【", "研报", "分析", "（PPT）", "（全文）"],
      },
    };
  },
  created() {
    this.$store.commit("textparams", this.params);
    // this.$store.commit("changeKeys", this.dataNav[0].value);
    if ((this.dataNav.value = "数字生活")) {
      this.$store.commit("changeKeys", this.list);
      this.$store.dispatch("getText2");
    } else {
      this.$store.dispatch("getText");
    }
    this.$store.state.allNav.forEach((item) => {
      item.child.forEach((j) => {
        if (this.$route.path.indexOf(j.url) != -1) {
          this.title = j.name;
          if (this.title == "首页") {
            this.title = "热点聚焦";
          }

          if (item.more != undefined) {
            this.more = item.more;
          } else if (j.more != undefined) {
            this.more = j.more;
          }
        }
      })
    });
    handleSelect3();

  },
  methods: {
    handleSelect(index) {
      this.iflist =  this.dataNav[index].value
      if (this.dataNav[index].value == "数字生活") {
        this.$store.commit("changeKeys", this.list);
        this.$store.dispatch("getText2");
      } else {
        this.$store.commit("changeKeys", this.dataNav[index].value);
        this.$store.dispatch("getText");
      }
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
    handleSelect3(){
      if (this.iflist == '数字生活') {
        this.$store.dispatch("getText2");
      } else {
        this.$store.dispatch("getText");
      }
    },
  },
};
</script>
<style scoped>
.title {
  position: relative;
}
.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right img {
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right img {
    width: 100%;
    height: 50px;
  }
}
</style>